export interface DevLink {
  label: string;
  href: string;
}

// Same gateway host/port as residential — the access point's own credentials
// (generated in Session Builder or the dashboard) determine which pool a
// connection draws from, so mobile and residential share one endpoint.
export const MOBILE_PLAYWRIGHT_EXAMPLE = `import { chromium } from "playwright";

const browser = await chromium.launch();
const context = await browser.newContext({
  proxy: {
    server: "http://gate.proxidize.com:7777",
    // Credentials generated for a mobile access point — append -country-{iso}
    // to target a country; city and session mode are set in Session Builder.
    username: "your_username-country-de",
    password: "your_password",
  },
});

const page = await context.newPage();
// Example: check a localized landing page as a German mobile user sees it.
await page.goto("https://your-site.com/de/campaign");
console.log(await page.title());
await browser.close();`;
